export default "__VITE_ASSET__LJS0mHwh__"